/**
 * Feature flag de cohabitation Clerk / Auth v2.
 *
 *  - `VITE_AUTH_PROVIDER=v2` → bascule sur le socle maison.
 *  - Toute autre valeur (ou absente) → Clerk (compat actuelle).
 *
 * On lit la variable une seule fois au démarrage pour éviter les ré-renders
 * inutiles et les comportements incohérents en cours de session.
 */
const rawProvider = (import.meta.env.VITE_AUTH_PROVIDER ?? "").toLowerCase();

export const AUTH_PROVIDER: "clerk" | "v2" =
  rawProvider === "v2" ? "v2" : "clerk";

export const isAuthV2 = (): boolean => AUTH_PROVIDER === "v2";
